import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vue-megamenu__inner"
}
const _hoisted_2 = {
  key: 0,
  class: "vue-megamenu__link-container"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_category = _resolveComponent("category")!

  return (_openBlock(), _createElementBlock("div", {
    class: "vue-megamenu__container",
    ref: "container",
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mouseover()))
  }, [
    (_ctx.hasCategories)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
            return (_openBlock(), _createBlock(_component_category, {
              category: category,
              isActive: _ctx.isActive,
              index: index,
              key: category.id + '-category'
            }, null, 8, ["category", "isActive", "index"]))
          }), 128)),
          (_ctx.hasLinks )
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: index + '-link',
                    href: link.url,
                    class: "vue-megamenu__link-container__link"
                  }, [
                    _createElementVNode("picture", null, [
                      _createElementVNode("img", {
                        src: link.image.replace(/(.jpg|.png)/, '_ew90_eh60.webp'),
                        width: "90",
                        height: "60",
                        loading: "lazy"
                      }, null, 8, _hoisted_4)
                    ]),
                    _createElementVNode("span", null, _toDisplayString(link.title), 1)
                  ], 8, _hoisted_3))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 544))
}